import { useEffect, useState } from 'react';

// Detecta deploy novo em produção. A cada 60s faz fetch de /version.json
// (gravado pelo plugin writeVersionFile do vite.config.ts a cada build).
// Se builtAt remoto for diferente do congelado no bundle atual (__BUILT_AT__),
// seta updateAvailable=true → UpdateToast aparece com botão Recarregar.
//
// Contexto: em 2026-07-08, Pablo abriu o admin com bundle antigo em cache
// (aba estava aberta durante deploy). Código novo importado dinamicamente
// referenciava símbolos que não existiam no bundle carregado → tela em
// branco. Solução foi Cmd+Shift+R. Toast dá a mesma solução sem exigir
// atalho de teclado.

// Em dev (vite dev server), __BUILT_AT__ não existe / não faz sentido.
// Fallback pra string vazia evita crash; polling nunca detecta mudança.
const CURRENT_BUILT_AT: string = typeof __BUILT_AT__ !== 'undefined' ? __BUILT_AT__ : '';

const POLL_INTERVAL_MS = 60_000;
const VERSION_URL = '/version.json';

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    // Em dev não há version.json em / — pular polling
    if (!CURRENT_BUILT_AT) return;

    let mounted = true;

    const check = async () => {
      try {
        const res = await fetch(VERSION_URL, { cache: 'no-store' });
        if (!res.ok) return;
        const { builtAt } = await res.json();
        if (mounted && builtAt && builtAt !== CURRENT_BUILT_AT) {
          setUpdateAvailable(true);
        }
      } catch {
        // silent — network offline, Cloudflare hiccup, etc.
      }
    };

    check();
    const id = setInterval(check, POLL_INTERVAL_MS);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  return updateAvailable;
}
